import { Component, input, output } from '@angular/core';
import { CrntButton, CrntIcon } from '@essent/current-web-angular';
import { SolarPanelsPropositionBoxFields } from '@feh/solar-panels-models';
import { ScFieldValuePipe } from '@innogy/feh/shared';
import {
  GenericModalSources,
  type GenericModalProps,
} from '@legacy/common-ui-shared-interfaces';

@Component({
  selector: 'wl-solar-panels-proposition-box',
  standalone: true,
  templateUrl: './solar-panels-proposition-box.component.html',
  styleUrls: [
    './solar-panels-proposition-box.component.ed.scss',
    './solar-panels-proposition-box.component.essent.scss',
  ],
  imports: [ScFieldValuePipe, CrntIcon, CrntButton],
})
export class SolarPanelsPropositionBoxComponent {
  readonly rendering = input.required<{
    fields: SolarPanelsPropositionBoxFields;
  }>();
  readonly openInfoModal = output<GenericModalProps>();

  openMoreInfoModal() {
    if (this.rendering().fields.PropositionMoreInfoModal) {
      const { Body, Title, ComponentName } =
        this.rendering().fields.PropositionMoreInfoModal?.fields || {};

      this.openInfoModal.emit({
        body: Body?.value ?? '',
        source: GenericModalSources.GENERIC_MODAL,
        title: Title?.value ?? '',
        tracking: { componentName: ComponentName?.value ?? '' },
      });
    }
  }
}
